import { useEffect } from "react";
import { SignIn, SignUp, SignedIn, SignedOut, useAuth } from "@clerk/clerk-react";
import { useNavigate, Link, useLocation } from "@tanstack/react-router";
import { useSelector } from "react-redux";
import Unauthorized from "../components/unauthorized";

export function AuthenticationPage() {
  const { isSignedIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const roles = useSelector((s) => s.auth.roles) || [];
  const authorizedRoles = ["Admin", "Manager", "Tm", "Instructor"];
  const isAuthorized = roles.some((r) => authorizedRoles.includes(r));

  const pathname = location.pathname || "/";
  const isOnAuthRoute = pathname.startsWith("/sign-in") || pathname.startsWith("/sign-up");
  const isSignUpFlow = pathname.startsWith("/sign-up");

  useEffect(() => {
    if (isSignedIn) {
      if (pathname !== "/") navigate({ to: "/" });
      return;
    }
    // If not signed in and user hit a protected/unknown URL, send to sign-in
    if (!isOnAuthRoute) {
      navigate({ to: "/sign-in" });
    }
  }, [isSignedIn, pathname, isOnAuthRoute, navigate]);

  return (
    <div className="flex-1 flex flex-col items-center justify-center min-h-screen">
      <SignedOut>
        {isSignUpFlow ? (
          <SignUp routing="path" path="/sign-up" />
        ) : (
          <SignIn routing="path" path="/sign-in" />
        )}
      </SignedOut>

      <SignedIn>
        {isAuthorized ? (
          <div className="redirect-message">
            <p>You are already signed in.</p>
            <Link to="/">Go to Dashboard</Link>
          </div>
        ) : (
          <Unauthorized />
        )}
      </SignedIn>
    </div>
  );
}